import React from "react";

const FilledButton = ({
  text,
  textColor = "#ffffff",
  backgroundColor = "#5153F5",
  onPress,
  icon = null,
  marginTop = 0,
  fontSize = 16,
  borderRadius = 8,
}) => {
  return (
    <>
      <div
        onClick={onPress}
        className="cursor-pointer w-full p-2 flex flex-row justify-center items-center"
        style={{
          backgroundColor: backgroundColor,
          marginTop: marginTop,
          borderRadius: borderRadius,
        }}
      >
        {icon}
        <p
          className="text-center font-medium"
          style={{ color: textColor, fontSize: fontSize }}
        >
          {text}
        </p>
      </div>
    </>
  );
};

export default FilledButton;
